import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/api';

import { EmailLog, EmailLogs, GetEmailsParams, SendgridStatus } from './types';

@Injectable({
  providedIn: 'root'
})
export class EmailsService {
  private readonly apiService = inject(ApiService);

  getEmails(params: GetEmailsParams): Observable<EmailLogs> {
    return this.apiService.get<EmailLogs>('emails', { params });
  }

  getInvoiceEmails(invoiceId: number): Observable<EmailLog[]> {
    return this.apiService.get<EmailLog[]>(`emails/invoice/${invoiceId}`);
  }

  getSettlementEmails(settlementId: number): Observable<EmailLog[]> {
    return this.apiService.get<EmailLog[]>(`emails/settlement/${settlementId}`);
  }

  sendgridStatus(emailActivityID: number): Observable<SendgridStatus> {
    return this.apiService.get<SendgridStatus>(`emails/${emailActivityID}/sendgrid-status`);
  }
}
